var _defs, _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppWindowMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".app-window-mail_svg__app-window-mail_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "app-window-mail_svg__app-window-mail_svg__a",
    x: 1.51,
    y: 2.253,
    width: 21,
    height: 19.5,
    rx: 1.5,
    ry: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "app-window-mail_svg__app-window-mail_svg__a",
    d: "M1.51 6.753h21m-4.5 4.5v6a1.5 1.5 0 01-1.5 1.5h-9a1.5 1.5 0 01-1.5-1.5v-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "app-window-mail_svg__app-window-mail_svg__a",
    d: "M18.01 11.253a1.5 1.5 0 00-1.5-1.5h-9a1.5 1.5 0 00-1.5 1.5l5.205 3.254a1.5 1.5 0 001.59 0z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MS41cHg7fTwvc3R5bGU+PC9kZWZzPjxyZWN0IGNsYXNzPSJhIiB4PSIxLjUxIiB5PSIyLjI1MyIgd2lkdGg9IjIxIiBoZWlnaHQ9IjE5LjUiIHJ4PSIxLjUiIHJ5PSIxLjUiLz48bGluZSBjbGFzcz0iYSIgeDE9IjEuNTEiIHkxPSI2Ljc1MyIgeDI9IjIyLjUxIiB5Mj0iNi43NTMiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTE4LjAxLDExLjI1M3Y2YTEuNSwxLjUsMCwwLDEtMS41LDEuNWgtOWExLjUsMS41LDAsMCwxLTEuNS0xLjV2LTYiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTE4LjAxLDExLjI1M2ExLjUsMS41LDAsMCwwLTEuNS0xLjVoLTlhMS41LDEuNSwwLDAsMC0xLjUsMS41bDUuMjA1LDMuMjU0YTEuNSwxLjUsMCwwLDAsMS41OSwwWiIvPjwvc3ZnPgo=";
export { SvgAppWindowMail as ReactComponent };